import React, { useState } from "react";
import { Stack, TextField, PrimaryButton, DefaultButton, Text } from "@fluentui/react";
import { AccountRegService } from "../../services";

interface Props {
    accountRegId: number;
    email: string;
    onVerified: () => void;
    onBack: () => void;
}

export const StepVerifyEmail: React.FC<Props> = ({
    accountRegId,
    email,
    onVerified,
    onBack
}) => {
    const accountRegService = new AccountRegService();

    const [code, setCode] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const maskEmail = (email: string) => {
        const [name, domain] = email.split("@");
        return `${name[0]}****@${domain}`;
    };

    const handleVerify = async () => {
        if (!code) {
            setError("Enter verification code");
            return;
        }

        setLoading(true);
        setError("");

        try {
            const result = await accountRegService.verifyEmail(accountRegId, code);

            if (result === true) {
                onVerified();
            } else {
                setError("Invalid code");
            }
        } catch (err) {
            setError("Verification failed");
        }

        setLoading(false);
    };

    return (
        <Stack tokens={{ childrenGap: 20 }} styles={{ root: { maxWidth: 400 } }}>
            <Text variant="xLarge">Verify Your Email</Text>

            <Text>
                We’ve sent a 6-digit code to {maskEmail(email)}
            </Text>

            <TextField
                label="Verification Code"
                value={code}
                onChange={(_, val) => setCode(val || "")}
                maxLength={6}
            />

            {error && <Text styles={{ root: { color: "red" } }}>{error}</Text>}

            <Stack horizontal tokens={{ childrenGap: 10 }}>
                <DefaultButton
                    text="Back"
                    onClick={onBack}
                />
                <PrimaryButton
                    text="Continue"
                    onClick={handleVerify}
                    disabled={loading}
                />
            </Stack>
        </Stack>
    );
};